import {
  faBlockQuestion,
  faClapperboardPlay,
  faClock,
  faHeart,
  faPenToSquare,
  faRocketLaunch,
  faTrash,
} from '@fortawesome/pro-light-svg-icons'
import { faHeart as faHeartSolid } from '@fortawesome/pro-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Card, IconButton } from '@mui/material'
import dayjs from 'dayjs'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { SUMMARY_DATE } from '@/api/constants'
import CardHeader from '@/common/components/Card/CardHeader'
import CardSummeryIcon from '@/common/components/Card/CardSummeryIcon'
import { theme } from '@/theme/theme'
import { VideosPackageResponse } from '@/types/videos'
import { useAuth } from '@/context/Auth'
import { useToggleSavedAssetPackage } from '@/api/profile/toggle-saved-asset-package'
import useToast from '@/common/hooks/useToast'

type SummaryParams = { openDeletePopup: () => void; videosPackage: VideosPackageResponse }
const Summary: FC<SummaryParams> = ({ openDeletePopup, videosPackage }) => {
  const { t } = useTranslation()
  const { errorToast } = useToast()

  const { user: { saved_asset_packages = [] } = {} } = useAuth()
  const { mutateAsync: toggleSavedAssetPackage } = useToggleSavedAssetPackage()

  const navigate = useNavigate()

  const handlePackageEdit = (videoPackage: VideosPackageResponse) => {
    navigate(`/content-library/videos?editPackage=${videoPackage.id}`)
  }

  const handleSavePackage = async () => {
    try {
      await toggleSavedAssetPackage(videosPackage.id)
    } catch (error) {
      errorToast(t('simulationLibrary.errors.failedToSave'))
    }
  }

  const totalQuizzes = videosPackage.videos.filter(
    (video) => video?.number_of_quiz_questions && video.number_of_quiz_questions > 0
  ).length

  return (
    <Card>
      <CardHeader title={t('videosPackage.sumarry.title')} subtitle={videosPackage.name}>
        <Box color={theme.palette.blueGray[900]}>
          <IconButton color="inherit" onClick={openDeletePopup}>
            <FontAwesomeIcon icon={faTrash}></FontAwesomeIcon>
          </IconButton>

          <IconButton color="inherit" onClick={() => handlePackageEdit(videosPackage)}>
            <FontAwesomeIcon icon={faPenToSquare}></FontAwesomeIcon>
          </IconButton>
          <IconButton onClick={handleSavePackage}>
            <FontAwesomeIcon
              icon={saved_asset_packages.includes(videosPackage.id) ? faHeartSolid : faHeart}
              color={theme.palette.pink[500]}
            />
          </IconButton>
        </Box>
      </CardHeader>
      <Box display="flex" justifyContent="stretch" marginTop={2}>
        <CardSummeryIcon
          subtitle={t('videosPackage.sumarry.createdOn')}
          title={dayjs(videosPackage.created_at).format(SUMMARY_DATE)}
          Icon={faClock}
        />
        <CardSummeryIcon
          subtitle={t('videosPackage.sumarry.lastEdit')}
          title={dayjs(videosPackage.updated_at || videosPackage.created_at).format(SUMMARY_DATE)}
          Icon={faPenToSquare}
        />
        <CardSummeryIcon
          subtitle={t('videosPackage.sumarry.lastLaunch')}
          title={videosPackage.last_launch_at ? dayjs(videosPackage.last_launch_at).format(SUMMARY_DATE) : '-'}
          Icon={faRocketLaunch}
        />
        <CardSummeryIcon
          subtitle={t('videosPackage.sumarry.totalVideos')}
          title={videosPackage.videos.length || 0}
          Icon={faClapperboardPlay}
        />
        <CardSummeryIcon
          subtitle={t('videosPackage.sumarry.totalQuizzes')}
          title={totalQuizzes}
          Icon={faBlockQuestion}
        />
      </Box>
    </Card>
  )
}

export default Summary
